<template>
  <page-layout>
    <a-card>欢迎使用！</a-card>
  </page-layout>
</template>

<script>
import PageLayout from "@/layouts/PageLayout.vue";
export default {
  name: "Index",
  components: {
    PageLayout
  }
};
</script>
<style lang="less" scoped>
iframe {
  width: 100%;
  height: calc(100vh - 65px);
}
</style>